import authStore from './auth';
import commonStore from './common';
import cartState from './cart';
import flag from './flag';
import orderFlag from './orderFlag';

export const MODULES = {
    authStore,
    commonStore,
    cartState,
    flag,
    orderFlag
};